'use strict';

var Radio = require('backbone.radio');
var StepTitleView = require('../step-title').default;
var Marionette = require('backbone.marionette');
var Tracker = require('../../../analytics/events').default;
var polyglot = require('../../utilities/polyglot').default;
var EmptyView = require('../appointments/no-appointments').default;
var AppointmentDetailsView = require('../appointments/details').default;

/* global window */
export default Marionette.View.extend({

  className: 'l-confirmation',
  template: require('./templates/confirmation.hbs'),
  regions: {
    title: '.l-confirmation-title',
    body: '.l-confirmation-body',
  },

  initialize: function (options) {
    this.titleView = new StepTitleView({
      title: polyglot.t('pages.confirmation.title'),
    });

    this.exists = (window.APPOINTMENTS.length);
    if (this.exists) {
      this.bodyView = new AppointmentDetailsView({
        clientEnd: options.clientEnd,
        showMessage: options.showMessage,
      });
    } else {
      this.bodyView = new EmptyView(polyglot.t('pages.confirmation.cancel'));
    }

    var previousStep = Radio.channel('steps').request('previous', 'confirmation');
    if (previousStep === 'detailsStep' || previousStep === 'paymentStep') {
      Tracker.trackView('confirmation');
    }

    Tracker.getConversionsDataAndTrack();
  },

  onRender: function () {
    this.getRegion('title').show(this.titleView);
    this.getRegion('body').show(this.bodyView);
  },

  onDomRefresh: function () {
    this.bodyView.focus();
  },

});
